/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import Vue from 'vue';
import ElementUI from 'element-ui';
import Vuex from 'vuex';
import lang from 'element-ui/lib/locale/lang/fr';
import locale from 'element-ui/lib/locale';
import * as Sentry from '@sentry/browser';
import store from './store';
import Notifications from './notifications';

window.Vue = Vue;


if (process.env.NODE_ENV == 'production') {
    Sentry.init({
        dsn: 'https://7071449046ca463782aac52c95a2992f@sentry.io/1315951',
        release: process.env.RELEASE,
        integrations: [new Sentry.Integrations.Vue(), new Sentry.Integrations.RewriteFrames()]
    });
}

locale.use(lang);

Vue.use(Vuex);
Vue.use(ElementUI);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */


Vue.component('catalog-list', require('./components/Catalog/List.vue').default);
Vue.component('catalog-filters', require('./components/Catalog/Filters.vue').default);
Vue.component('gallery-selector', require('./components/GallerySelector/GallerySelector.vue').default);
Vue.component('lab', require('./components/Lab.vue').default);
Vue.component('catalog-edit', require('./components/Catalog/Edit.vue').default);
Vue.component('search-input', require('./components/SearchInput.vue').default);
Vue.component('autocomplete', require('./components/Autocomplete.vue').default);
Vue.component('product-variations', require('./components/Catalog/ProductVariations.vue').default);
Vue.component('product-regroupment', require('./components/Catalog/ProductRegroupment.vue').default);
Vue.component('product-accessories', require('./components/Catalog/ProductAccessories.vue').default);
Vue.component('product-synthese-display', require('./components/Catalog/SyntheseDisplay.vue').default);
Vue.component('category-list', require('./components/Category/CategoryList.vue').default);
Vue.component('category-filters', require('./components/Category/Filters.vue').default);
Vue.component('vehicule-list', require('./components/Vehicule/List.vue').default);
Vue.component('vehicule-filters', require('./components/Vehicule/Filters.vue').default);
Vue.component('vehicule-cascader', require('./components/Vehicule/Cascader.vue').default);
Vue.component('brand-list', require('./components/Brand/List.vue').default);
Vue.component('brand-filters', require('./components/Brand/Filters.vue').default);
Vue.component('manufacturer-list', require('./components/Manufacturer/List.vue').default);
Vue.component('manufacturer-filters', require('./components/Manufacturer/Filters.vue').default);
Vue.component('dashboard', require('./components/Dashboard/Index.vue').default);
Vue.component('product-difference', require('./components/Catalog/ProductDifference.vue').default);
Vue.component('product-edit-vehicules', require('./components/Catalog/EditVehicules.vue').default);
Vue.component('product-edit-features', require('./components/Catalog/EditFeatures.vue').default);
Vue.component('product-edit-attachments', require('./components/Catalog/EditAttachments.vue').default);

Vue.component('notifications-unread', require('./components/Notifications/Unread.vue').default);
Vue.component('notifications-list', require('./components/Notifications/List.vue').default);
Vue.component('notifications-index', require('./components/Notifications/Index.vue').default);

Vue.component('review-list', require('./components/Review/List.vue').default);
Vue.component('feature-list', require('./components/Feature/List.vue').default);
Vue.component('feature-filters', require('./components/Feature/Filters.vue').default);
Vue.component('feature-edit', require('./components/Feature/Edit.vue').default);
Vue.component('variation-values-list', require('./components/VariationValues/List.vue').default);
Vue.component('variation-values-filters', require('./components/VariationValues/Filters.vue').default);
Vue.component('editor', require('./components/Editor.vue').default);
Vue.component('user-list', require('./components/User/List.vue').default);

Vue.component('product-type-list', require('./components/ProductType/List.vue').default);
Vue.component('product-type-edit', require('./components/ProductType/Edit.vue').default);
Vue.component('product-type-filters', require('./components/ProductType/Filters.vue').default);

Vue.component('file-list', require('./components/File/List.vue').default);
Vue.component('file-filters', require('./components/File/Filters.vue').default);

Vue.component('comarch-review-list', require('./components/ComarchReview/List.vue').default);

Vue.component('btn-stock', require('./components/BtnStock.vue').default);

Vue.component('comarch-dashboard', require('./components/Comarch/Dashboard.vue').default);
Vue.component('carrier-selector', require('./components/Carrier/CarrierSelector.vue').default);
Vue.component('discount', require('./components/Discount/Discount.vue').default);
Vue.component('repricing-test', require('./components/Discount/RepricingTest.vue').default);

Vue.directive('click-outside', {
    bind: function(el, binding, vnode) {
        el.clickOutsideEvent = function(event) {
            // here I check that click was outside the el and his children
            if (!(el == event.target || el.contains(event.target))) {
                // and if it did, call method provided in attribute value
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
    },
    unbind: function(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
    }
});

store.dispatch('app/setUser').then(() => {
    const app = new Vue({
        el: '#app',
        store
    });
});

Notifications.fetch().then(() => {
    Notifications.start();
});

